import { showAction as lockUi, hideAction as unlockUi } from '../../../_flux/actions/ui_lock_actions';
import { setValue, clearValue } from '../../../utilities/local_storage';
import API from '../../../API/api';

export const setPreselectFS = async (param, urlParams, type) => {
  try {
    let response;
    let customerDefaultAddress;
    const isPdpV1Page = TYROOLA.page.$container.hasClass('product') && location.pathname.slice(0, 3) === '/v1';
    if (param && !isPdpV1Page) {
      if (type === 'catalog') {
        param.catalogUrl = `${location.origin}${location.pathname}`;
      }
      response = await API.POST({
        apiPath: '/api/v2/checkout/preselectfittingstation/',
        data: JSON.stringify({ ...param }),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
      });

      if (response) {
        customerDefaultAddress = response.customerDefaultAddress;

        if (!param.fsId) {
          const postcode = `${customerDefaultAddress.postcode}, ${
            customerDefaultAddress.suburb || customerDefaultAddress.city
          }`;
          const latLng = {
            lat: customerDefaultAddress.latitude,
            lng: customerDefaultAddress.longitude,
          };
          setValue('shippingPostcode', postcode);
          setValue('shippingState', customerDefaultAddress.state);
          setValue('latLng', latLng);
          setValue('bust', true);

          window.uiLockText = '';
          unlockUi();
          let urlStart = response.regionalCatalogUrl
            ? response.regionalCatalogUrl
            : `${location.origin}${location.pathname}`;

          if (urlParams) {
            // If outlet_id or zipcode exists
            if (param.spinachIdF) {
              urlParams.delete('outlet_id');
            }
            if (param.postcode) {
              urlParams.delete('zipcode');
            }

            location.href = `${urlStart}?${urlParams.toString()}`;
          } else {
            if (response.regionalCatalogUrl) {
              location.href = `${urlStart}${location.search}`;
            } else {
              location.reload();
            }
          }
        } else {
          const postcode = `${customerDefaultAddress.postcode}, ${
            customerDefaultAddress.suburb || customerDefaultAddress.city
          }`;
          const latLng = {
            lat: customerDefaultAddress.latitude,
            lng: customerDefaultAddress.longitude,
          };
          setValue('shippingPostcode', postcode);
          setValue('shippingState', customerDefaultAddress.state);
          setValue('latLng', latLng);
          setValue('bust', true);
          return Promise.resolve(response);
        }
      }
    } else {
      window.uiLockText = '';
      unlockUi();
    }
  } catch (error) {
    window.uiLockText = '';
    unlockUi();
    clearValue('shippingPostcode');
    clearValue('shippingState');
    clearValue('latLng');
    if (error && error.responseJSON) {
      return Promise.resolve(error.responseJSON);
    }
  }
};
